import styled from 'styled-components';

export const PostsContainer = styled.div`
  position: relative;
  top: -75px;
  max-width: 860px;
  padding: 0 10px;

  @media only screen and (max-width: 860px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* width: 100%; */
  }

  @media (max-width: 800px) {
    /* width: 100vw; */
    top: 0px;
  }
  margin: 0 auto;
`;

export const UserDetailsWrap = styled.div`
  padding-top: 30px;
  max-width: 860px;
  margin: 0 auto;
  width: 100%;
  /* overflow: hidden; */

  @media only screen and (max-width: 860px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
